// Inform state when the browser goes offline/online
type ConnectivtyChangeCallbackType = (isOnline: boolean) => void

function observeConnectivity(callbackFn: ConnectivtyChangeCallbackType) {
  window.addEventListener('online', () => {
    callbackFn(true)
  })

  window.addEventListener('offline', () => {
    callbackFn(false)
  })
}
export { observeConnectivity }
